@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.mark-as-paid-modal {
  width: 280px;
}

.modal-body {
  padding: 15px;

  button:hover {
    svg {
      fill: @mark-as-paid-modal--fill-color;
    }
  }

  .form-field {
    width: 150px;
  }

  .internal-note-input {
    width: 250px;
    height: 120px;
  }

  .form-field,
  .internal-note-input {
    padding: 5px 0;
  }
}

.modal-footer {
  height: initial;

  button:nth-child(even) {
    margin-left: 10px;
  }
}
